import { render, staticRenderFns } from "./PublisherReportCard.vue?vue&type=template&id=361918fa&scoped=true&"
import script from "./PublisherReportCard.vue?vue&type=script&lang=js&"
export * from "./PublisherReportCard.vue?vue&type=script&lang=js&"
import style0 from "./PublisherReportCard.vue?vue&type=style&index=0&id=361918fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361918fa",
  null
  
)

export default component.exports